import axiosInstance, { axiosInstanceV2, axiosInstanceV3 } from '../common/instance';

import {
  AgeByKidneyRisk,
  AtherosclerosisByKidneyRisk,
  CounterbyAccountDataTypes,
  CounterbyMonthDataTypes,
  CounterbyQuarterDataTypes,
  DateParams,
  DeviceList,
  GaLocationsTrackingTypes,
  GaPagesTrackingTypes,
  GaPageTrackingParamsTypes,
  GaPageTrackingTypes,
  GaSummariesParamsTypes,
  GaSummariesTypes,
  GaUsersTracking,
  GaVisitorParamsTypes,
  GaVisitorTracking,
  KioskAnalyticAtherosclerosisDataTypes,
  KioskAnalyticDataTypes,
  KioskAnalyticHeartRiskDataTypes,
  KioskAnnalyticKidneyRiskDataTypes,
  KioskByStatusDataTypes,
  KioskGroupReport,
  KioskHeartsRiskByMonthDataTypes,
  KioskHeartsRiskDataTypes,
  KioskKidneyRiskDataTypes,
  KioskWarrantyTypes,
  QuickActionSummaryParams,
  QuickActionSummaryType,
  SummariesDataRequest,
  SummariesDataRequestExtend,
  SummariesDataTypes,
  SurveyChartResponseDataTypes,
  TopActivityLogsTypes,
  YearDataTypes,
  YTNCByHeartRisk,
  YTNCByMonthDataTypes,
  YTNCDataTypes,
  YTNCForOneByHeartRisk,
  YTNCForOneByKidneyRisk,
  YTNCForPieDataTypes
} from './types';

const prefixPath = 'dashboard/';

export const getTopActivityLogsService = async (): Promise<
  TopActivityLogsTypes[]
> => {
  const res = await axiosInstance.get(`${prefixPath}top-activity-logs`);
  return res.data.data;
};
/**
 * ga Key
 * identifier, users, sessions, avgSessionDuration, pageviewsPerSession,
 * newUsers, bounceRate, adMatchedQuery
 */

const postGaSummariesService = async (
  params: GaSummariesParamsTypes
): Promise<GaSummariesTypes[]> => {
  /**
   * metrics: sessions, activeUsers
   * groupBy: date, yearMonth
   */
  const res = await axiosInstance.post(`${prefixPath}ga-summaries`, params);
  return res.data.data;
};

export const postGaPagesTrackingService = async (
  params: GaSummariesParamsTypes
): Promise<GaPagesTrackingTypes[]> => {
  /**
   * Metric: newUsers, engagedSessions, engagementRate,
   * bounceRate, itemViews, screenPageViewsPerSession, screenPageViews
   */
  const res = await axiosInstance.post(
    `${prefixPath}ga-pages-tracking`,
    params
  );
  return res.data.data;
};

export const postGaUsersTrackingService = async (
  params: GaSummariesParamsTypes
): Promise<GaUsersTracking[]> => {
  // region, country, deviceCategory, browser
  const res = await axiosInstance.post(
    `${prefixPath}ga-users-tracking`,
    params
  );
  return res.data.data;
};
export const getGaVisitorTrackingService = async (
  params: GaVisitorParamsTypes
): Promise<GaVisitorTracking[]> => {
  const res = await axiosInstance.get(`${prefixPath}ga-visitors-tracking`, { params });
  return res.data.data;
};

export const quickActionSummariesService = async (
  params: QuickActionSummaryParams
): Promise<QuickActionSummaryType[]> => {
  const res = await axiosInstance.get(
    `${prefixPath}${params.prefix}-summaries`
  );
  return res.data.data;
};

export const getGAPageTrackingList = async (
  params: GaPageTrackingParamsTypes
): Promise<GaPageTrackingTypes[]> => {
  const res = await axiosInstance.get(`${prefixPath}ga-pages-tracking`, { params });
  return res.data.data;
};

export const getGaLocationTracking = async (
  params: DateParams
): Promise<GaLocationsTrackingTypes[]> => {
  // region, country, deviceCategory, browser
  const res = await axiosInstance.get(`${prefixPath}ga-locations-tracking`, { params });
  return res.data.data;
};

export const getDeviceTrackingService = async (
  params: DateParams,
): Promise<DeviceList[]> => {
  const res = await axiosInstance.get(`${prefixPath}ga-devices-tracking`, { params });
  return res.data.data;
};

export const getOldSurveyHeartRiskService = async (
  params: DateParams,
): Promise<SurveyChartResponseDataTypes[]> => {
  const res = await axiosInstance.get('old-data-reports/surveys/heart-risk', { params });
  return res.data.data;
};

export const getOldSurveyCountersService = async (
  params: DateParams,
): Promise<SurveyChartResponseDataTypes[]> => {
  const res = await axiosInstance.get('old-data-reports/surveys/counters', { params });
  return res.data.data;
};

export const getOldSurveyKidneyRiskService = async (
  params: DateParams,
): Promise<SurveyChartResponseDataTypes[]> => {
  const res = await axiosInstance.get('old-data-reports/surveys/kidney-risk', { params });
  return res.data.data;
};

export const getSurveyHeartRiskService = async (
  params: DateParams,
): Promise<SurveyChartResponseDataTypes[]> => {
  const res = await axiosInstance.get('reports/survey-results/heart-risk', { params });
  return res.data.data;
};

export const getSurveyCountersService = async (
  params: DateParams,
): Promise<SurveyChartResponseDataTypes[]> => {
  const res = await axiosInstance.get('reports/survey-results/counters', { params });
  return res.data.data;
};

export const getSurveyKidneyRiskService = async (
  params: DateParams,
): Promise<SurveyChartResponseDataTypes[]> => {
  const res = await axiosInstance.get('reports/survey-results/kidney-risk', { params });
  return res.data.data;
};

export const getReportSummariesService = async (
  params: DateParams,
): Promise<{ link: string }> => {
  const res = await axiosInstance.get('reports/summaries', { params });
  return res.data.data;
};

export const getReportEvaluationsService = async (
  params: DateParams,
): Promise<{ link: string }> => {
  const res = await axiosInstance.get('reports/evaluations', { params });
  return res.data.data;
};

export const getReportSummaryGropupService = async (
  params: DateParams,
): Promise<{ link: string }> => {
  const res = await axiosInstance.get('reports/summary-groups', { params });
  return res.data.data;
};

export const getReportSummaryEventService = async (
  params: DateParams,
): Promise<{ link: string }> => {
  const res = await axiosInstance.get('reports/summary-events', { params });
  return res.data.data;
};

export const getReportSummaryTrackingQrsService = async (
  params: DateParams,
): Promise<{ link: string }> => {
  const res = await axiosInstance.get('reports/summary-tracking-qrs', { params });
  return res.data.data;
};

export const getReportSummaryOnlyHaveQrsService = async (
  params: DateParams,
): Promise<{ link: string }> => {
  const res = await axiosInstance.get('reports/summary-only-have-qrs', { params });
  return res.data.data;
};

// V2
export const getSurveyHeartRiskV2Service = async (
  params: DateParams,
): Promise<SurveyChartResponseDataTypes[]> => {
  const res = await axiosInstanceV2.get('reports/survey-results/heart-risk', { params });
  return res.data.data;
};

export const getSurveyCountersV2Service = async (
  params: DateParams,
): Promise<SurveyChartResponseDataTypes[]> => {
  const res = await axiosInstanceV2.get('reports/survey-results/counters', { params });
  return res.data.data;
};

export const getSurveyKidneyRiskV2Service = async (
  params: DateParams,
): Promise<SurveyChartResponseDataTypes[]> => {
  const res = await axiosInstanceV2.get('reports/survey-results/kidney-risk', { params });
  return res.data.data;
};

export const getSummariesHeartRiskV2Service = async (
  params?: DateParams,
): Promise<{ link: string }> => {
  const res = await axiosInstanceV2.get('reports/heart-risk-summaries', { params });
  return res.data.data;
};

export const getSummariesKidneyRiskV2Service = async (
  params?: DateParams,
): Promise<{ link: string }> => {
  const res = await axiosInstanceV2.get('reports/kidney-risk-summaries', { params });
  return res.data.data;
};

export const getSummariesCounterV2Service = async (
  params?: DateParams,
): Promise<{ link: string }> => {
  const res = await axiosInstanceV2.get('reports/counter-summaries', { params });
  return res.data.data;
};

export const getSummariesPeriodsV2Service = async (
  params?: DateParams,
): Promise<{ link: string }> => {
  const res = await axiosInstance.get('reports/summary-periods', { params });
  return res.data.data;
};

export const getSummariesHeartRiskPeriodsV2Service = async (
  params?: DateParams,
): Promise<{ link: string }> => {
  const res = await axiosInstance.get('reports/summary-heartrisk-periods', { params });
  return res.data.data;
};

export const getKioskGroupSummariesV3Service = async (params?: SummariesDataRequest)
  : Promise<SummariesDataTypes[]> => {
  const res = await axiosInstanceV3.get('reports/kiosk-group-summaries', { params });
  return res.data.data;
};

export const getKioskGroupByYearV3Service = async (params?: SummariesDataRequest)
  : Promise<YearDataTypes[]> => {
  const res = await axiosInstanceV3.get('reports/total-kiosk-group-by-year', { params });
  return res.data.data;
};

export const getKioskCounterByMonthV3Service = async (params?: SummariesDataRequest)
  : Promise<CounterbyMonthDataTypes[]> => {
  const res = await axiosInstanceV3.get('reports/counter-by-month', { params });
  return res.data.data;
};

export const getKioskCounterByAccountV3Service = async (params?: SummariesDataRequest)
  : Promise<CounterbyAccountDataTypes[]> => {
  const res = await axiosInstanceV3.get('reports/counter-by-account', { params });
  return res.data.data;
};

export const getKioskByStatusAccountV3Service = async (): Promise<KioskByStatusDataTypes[]> => {
  const res = await axiosInstanceV3.get('reports/get-kiosk-by-status');
  return res.data.data;
};

export const getKioskAnnalyticV3Service = async (params?: SummariesDataRequest)
  : Promise<KioskAnalyticDataTypes> => {
  const res = await axiosInstanceV3.get('reports/get-analytic', { params });
  return res.data.data;
};

export const getKioskAnnalyticHeartRiskV3Service = async (params?: SummariesDataRequest)
  : Promise<KioskAnalyticHeartRiskDataTypes> => {
  const res = await axiosInstanceV3.get('reports/get-analytic-heart-risk', { params });
  return res.data.data;
};

export const getKioskAnnalyticAtherosclerosisV3Service = async (params?: SummariesDataRequest)
  : Promise<KioskAnalyticAtherosclerosisDataTypes> => {
  const res = await axiosInstanceV3.get('reports/get-atherosclerosis', { params });
  return res.data.data;
};

export const getKioskAnnalyticKidneyRiskV3Service = async (params?: SummariesDataRequest)
  : Promise<KioskAnnalyticKidneyRiskDataTypes> => {
  const res = await axiosInstanceV3.get('reports/get-analytic-kidney-risk', { params });
  return res.data.data;
};

export const getKioskKidneyRiskV3Service = async (params?: SummariesDataRequest)
  : Promise<KioskKidneyRiskDataTypes[]> => {
  const res = await axiosInstanceV3.get('reports/get-kidney-risk', { params });
  return res.data.data;
};

export const getKioskHeartRiskV3Service = async (params?: SummariesDataRequest)
  : Promise<KioskHeartsRiskDataTypes[]> => {
  const res = await axiosInstanceV3.get('reports/get-heart-risk', { params });
  return res.data.data;
};

export const getKioskHeartRiskByMonthV3Service = async (params?: SummariesDataRequest)
  : Promise<KioskHeartsRiskByMonthDataTypes[]> => {
  const res = await axiosInstanceV3.get('reports/get-heart-risk-by-month', { params });
  return res.data.data;
};

export const getYTNCByMonthV3Service = async (params?: SummariesDataRequestExtend)
  : Promise<YTNCByMonthDataTypes> => {
  const res = await axiosInstanceV3.get('reports/get-ytnc-by-month', { params });
  return res.data.data;
};

export const getYTNCForOneV3Service = async (params?: SummariesDataRequestExtend)
  : Promise<YTNCForPieDataTypes> => {
  const res = await axiosInstanceV3.get('reports/get-ytnc-for-one', { params });
  return res.data.data;
};

export const getYTNCForTwoV3Service = async (params?: SummariesDataRequestExtend)
  : Promise<YTNCForPieDataTypes> => {
  const res = await axiosInstanceV3.get('reports/get-ytnc-for-two', { params });
  return res.data.data;
};

export const getYTNCForThreeV3Service = async (params?: SummariesDataRequestExtend)
  : Promise<YTNCForPieDataTypes> => {
  const res = await axiosInstanceV3.get('reports/get-ytnc-for-three', { params });
  return res.data.data;
};

export const getKioskWarrantyV3Service = async (params?: SummariesDataRequestExtend)
  : Promise<KioskWarrantyTypes[]> => {
  const res = await axiosInstanceV3.get('reports/get-kiosk-warranty', { params });
  return res.data.data;
};

export const getKioskCumulativeByMonthV3Service = async (params?: SummariesDataRequest)
  : Promise<CounterbyMonthDataTypes[]> => {
  const res = await axiosInstanceV3.get('reports/counter-cumulative-by-month', { params });
  return res.data.data;
};

export const getCounterResultV3Service = async (params?: SummariesDataRequest)
  : Promise<{ total: number }> => {
  const res = await axiosInstanceV3.get('reports/counter-result', { params });
  return res.data.data;
};

export const getCounterHeartRiskHighAndVeryHighV3Service = async (params?: SummariesDataRequest)
  : Promise<{ total: number }> => {
  const res = await axiosInstanceV3.get('reports/counter-heart-risk-high-and-very-high', { params });
  return res.data.data;
};

export const getCounterKidneyRiskTwentyPercentV3Service = async (params?: SummariesDataRequest)
  : Promise<{ total: number }> => {
  const res = await axiosInstanceV3.get('reports/counter-kidney-risk-twenty-percent', { params });
  return res.data.data;
};

export const getCounterKidneyRiskStageThreeAndFourV3Service = async (params?: SummariesDataRequest)
  : Promise<{ total: number }> => {
  const res = await axiosInstanceV3.get('reports/counter-kidney-risk-stage-three-and-four', { params });
  return res.data.data;
};

export const getKioskGroupReportV3Service = async (
  params?: SummariesDataRequestExtend
):
  Promise<APIPaginationResponse<KioskGroupReport[]>> => {
  const res = await axiosInstanceV3.get('reports/get-kiosk-group-report', { params });
  return res.data;
};

export const getYTNCV3Service = async (params?: SummariesDataRequestExtend)
  : Promise<YTNCDataTypes> => {
  const res = await axiosInstanceV3.get('reports/get-ytnc', { params });
  return res.data.data;
};

export const getYTNCByHeartRiskV3Service = async (params?: SummariesDataRequestExtend)
  : Promise<YTNCByHeartRisk> => {
  const res = await axiosInstanceV3.get('reports/get-ytnc-by-heart-risk', { params });
  return res.data.data;
};

export const getAtherosclerosisV3Service = async (params?: SummariesDataRequestExtend)
  : Promise<KioskAnalyticAtherosclerosisDataTypes> => {
  const res = await axiosInstanceV3.get('reports/get-atherosclerosis', { params });
  return res.data.data;
};

export const getYTNCForOneByHeartRiskV3Service = async (params?: SummariesDataRequestExtend)
  : Promise<YTNCForOneByHeartRisk> => {
  const res = await axiosInstanceV3.get('reports/get-ytnc-for-one-by-heart-risk', { params });
  return res.data.data;
};

export const getCounterByTMXVV3Service = async (params?: SummariesDataRequestExtend)
  : Promise<{ total: number }> => {
  const res = await axiosInstanceV3.get('reports/counter-by-tmxv', { params });
  return res.data.data;
};

export const getAgeByKidneyRiskV3Service = async (params?: SummariesDataRequestExtend)
  : Promise<AgeByKidneyRisk[]> => {
  const res = await axiosInstanceV3.get('reports/get-age-by-kidney-risk', { params });
  return res.data.data;
};

export const getAtherosclerosisByKidneyRiskV3Service = async (params?: SummariesDataRequestExtend)
  : Promise<AtherosclerosisByKidneyRisk> => {
  const res = await axiosInstanceV3.get('reports/get-atherosclerosis-by-kidney-risk', { params });
  return res.data.data;
};

export const getYTNCForOneByKidneyRiskV3Service = async (params?: SummariesDataRequestExtend)
  : Promise<YTNCForOneByKidneyRisk> => {
  const res = await axiosInstanceV3.get('reports/get-ytnc-for-one-by-kidney-risk', { params });
  return res.data.data;
};

export const exportKioskGroupReportV3Service = async (params?: SummariesDataRequestExtend)
  : Promise<{ link: string }> => {
  const res = await axiosInstanceV3.get('reports/export-kiosk-group-report', { params });
  return res.data.data;
};

export const getCounterByQuarterV3Service = async (params?: SummariesDataRequest)
  : Promise<CounterbyQuarterDataTypes[]> => {
  const res = await axiosInstanceV3.get('reports/counter-by-quarter', { params });
  return res.data.data;
};

export default postGaSummariesService;
